import type {
  Maybe,
  Scalars,
  CustomerCreateInput,
  CustomerPaymentTokens,
  CustomerOrder,
  SortEnum,
  GetOrdersSearchParams,
  AppliedCoupon,
  OrderItemInterface,
  CustomerOrders,
  BundleOrderItem,
  CustomerQuery,
  Customer,
  CustomerAddress,
  OrderAddress,
} from '@vue-storefront/magento-types';
import type { ExtendShippingCartAddress } from './cart';
import type { EInvoice } from './checkout';
import type { ExtendProductInterface } from './product';

export interface TWCustomerCreateInput extends Omit<CustomerCreateInput, 'firstname'> {
  firstname?: Scalars['String'];
}

export interface TWCustomerWithSocialLoginCreateInput extends TWCustomerCreateInput {
  type: Scalars['Int'];
  phone: Scalars['String'];
  uid?: Scalars['String'];
}

/**
 * @deprecated
 */
export interface ExtendCustomerCreateInput extends CustomerCreateInput {
  type: Scalars['Int'];
  phone: Scalars['String'];
  uid?: Scalars['String'];
}

/**
 * @deprecated
 */
export interface GenerateCustomerTokenMutationVariables {
  type: Scalars['Int'];
  email?: Scalars['String'];
  username?: Scalars['String'];
  password?: Scalars['String'];
  uid?: Scalars['String'];
}

export interface GenerateCustomerTokenMutationInput {
  email: Scalars['String'];
  password: Scalars['String'];
}

export interface GenerateCustomerTokenWithSocialLoginMutationInput {
  type: Scalars['Int'];
  email?: Scalars['String'];
  password?: Scalars['String'];
  uid?: Scalars['String'];
}

export type CustomerBasicInfo = Omit<NonNullable<CustomerQuery['customer']>, 'addresses'> & {
  exp?: number;
  gender?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  wishlists?: Customer['wishlists'];
  group?: {
    name?: Scalars['String'];
  };
};

export interface CustomerPaymentTokensQuery {
  customerPaymentTokens: CustomerPaymentTokens;
}

export interface TWAddressItem {
  city: Scalars['String'];
  region: Scalars['String'];
  postal_code: Scalars['Int'];
}

export interface TWAddressListQuery {
  twAddressList: {
    items: TWAddressItem[];
  };
}

export enum OrderSortFieldEnum {
  Number = 'NUMBER',
  CreateAt = 'CREATED_AT',
}

export enum ScopeEnum {
  Global = 'GLOBAL',
  Website = 'WEBSITE',
  Store = 'STORE',
}

export type OrderProductType = 'simple' | 'configurable' | 'bundle';

export interface OrderSortInput {
  sort_direction: SortEnum;
  sort_field: OrderSortFieldEnum;
}

export interface ExtendGetOrdersSearchParams extends GetOrdersSearchParams {
  sort?: OrderSortInput;
  scope?: 'GLOBAL' | 'WEBSITE' | 'STORE';
}

export interface ExtendOrderItemInterface extends OrderItemInterface, BundleOrderItem {
  product?: Maybe<ExtendProductInterface>;
}

export interface StoreInfo {
  pickup_store_id: Scalars['String'];
  pickup_store_name: Scalars['String'];
}

export interface ExtendCustomerOrder extends CustomerOrder {
  applied_coupons?: Maybe<AppliedCoupon>;
  email?: Scalars['String'];
  items?: Maybe<Array<Maybe<ExtendOrderItemInterface>>>;
  token?: Scalars['String'];
  e_invoice?: Maybe<EInvoice>;
  seven_eleven_store_info?: Maybe<StoreInfo>;
  familymart_store_info?: Maybe<StoreInfo>;
  status_code: Scalars['String'];
}

export interface ExtendCustomerOrders extends CustomerOrders {
  items: Array<Maybe<ExtendCustomerOrder>>;
}

export interface CustomerOrdersQuery {
  customer?: {
    orders?: {
      total_count?: Scalars['Int'];
      page_info?: {
        current_page?: Scalars['Int'];
        page_size?: Scalars['Int'];
        total_pages?: Scalars['Int'];
      };
      items: ExtendCustomerOrder[];
    };
  };
}

export enum CardType {
  VI = 'visa',
  MC = 'mastercard',
  JCB = 'jcb',
  AE = 'amex',
  UN = 'unionpay',
}

export interface PaymentTokenDetails {
  type?: keyof typeof CardType;
  maskedCC?: Scalars['String'];
  bin_code?: Scalars['String'];
  last_four?: Scalars['String'];
  expirationDate?: Scalars['String'];
  card_key?: Scalars['String'];
  bank_id?: Scalars['String'];
  issuer_zh_tw?: Scalars['String'];
}

export type Address = ExtendShippingCartAddress | CustomerAddress | OrderAddress;
